import { useSearchParams } from '@framework/next/navigation';
import Flex from '@creditflowresearch/uilib/Flex';
import DropdownPanelButtons from '@creditflowresearch/uilib/DropdownPanelButtons';
import Links from '@creditflowresearch/uilib/Links';
import PanelContent from '@/creditflowresearch/ui/common/components/organisms/PanelContent/PanelContent';
import { getNavLinks, NAV_ITEMS } from '@/creditflowresearch/ui/common/constants/panelData';
import { useEmNavParams } from '@/creditflowresearch/ui/common/hooks/panels/useEmNavParams';
import LinksPanelButtons from '@creditflowresearch/uilib/LinksPanelButtons';
import headerLinksConfig from '@/creditflowresearch/ui/common/components/templates/HeaderLayout/headerLinksConfig';

import styles from './mobileNavigationMenu.module.scss';

interface IMobileNavigationMenuProps {
  links?: React.ReactNode,
}

const normalizeLinks = (links?: React.ReactNode): React.ReactNode[] => {
  if (!links) return [];
  return Array.isArray(links) ? links : [links];
};

const MobileNavigationMenu = ({
  links = <Links config={ headerLinksConfig } />,
}: IMobileNavigationMenuProps) => {
  const linksArray = normalizeLinks(links);
  const searchParams = useSearchParams();
  const markets = searchParams.get('markets');
  const emNavParams = useEmNavParams();
  const navLinks = getNavLinks({ markets }, emNavParams);

  const getPanelContent = (panelId: string) => <PanelContent panelId={ panelId } variant="mobile" />;

  return (
    <>
      <DropdownPanelButtons
        items={ NAV_ITEMS.map(({ href, ...rest }) => rest) }
        getPanelContent={ getPanelContent }
        className={ styles.panelButtonsSection }
      />
      <LinksPanelButtons items={ navLinks } />
      { linksArray.map((link) => (
        <Flex
          key={ `link-${ (link as any).props.label }` }
          className={ styles.linkItem }
          dataTest="expandedContentLink"
        >
          { link }
        </Flex>
      )) }
    </>
  );
};

export default MobileNavigationMenu;
